<template>
    <div>
        <TrialNagModal ref="trialModal"></TrialNagModal>
        <HardwareMismatchNagModal ref="hardwareMismatchModal"></HardwareMismatchNagModal>
        <ErrorModal></ErrorModal>
        <vue-topprogress ref="topProgress"></vue-topprogress>
        <router-view></router-view>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import TrialNagModal from "@/components/preview/TrialNagModal";
import HardwareMismatchNagModal from "@/components/preview/HardwareMismatchNagModal";
import ErrorModal from "@/components/general/ErrorModal";
import Poll from "@/mixins/Poll";
import Events from "@/mixins/Events";

export default {
    name: "App",

    components: {
        TrialNagModal,
        HardwareMismatchNagModal,
        ErrorModal
    },

    mixins: [
        //Poll,
        Events
    ],

    created() {

        this.initializeEvents();

        var temp = this;

        var route = JSON.parse(localStorage.getItem("previousRoute"));

        this.$store.dispatch("updateViewPostPage", route);

        this.$store.dispatch("loadServerInfo").then(function () {
            // Trial license nag (7 days or less remaining)
            if (temp.serverInfo.is_trial == 1) {
                if (temp.serverInfo.grace_days <= 7) {
                    temp.$refs.trialModal.open();
                }
            }
            // Hardware mismatch grace period nag
            // Shows on each app load, user can dismiss to continue working
            if (temp.serverInfo.is_hardware_mismatch && temp.serverInfo.hardware_mismatch_grace_period) {
                temp.$refs.hardwareMismatchModal.open();
            }
        });
        this.$store.dispatch("loadUser").then(function () {

            if (temp.category == "") {

                temp.$store.dispatch("updateCategory", "Home");
            }

        });

        this.$store.dispatch("loadEditingState");
    },

    watch: {
        userIsEditing() {
            if (this.socket.closed) {
                this.initializeEvents();
            }
        },
        appLoading(value) {
            if (value) {
                this.$refs.topProgress.start();
            } else {
                this.$refs.topProgress.done();
            }
        },
    },

    computed: {
        ...mapGetters(["user", "category", "serverInfo", "userIsEditing", "appLoading"])
    },
}
</script>

<style lang="less">
@import "@/assets/less/style.less";

//these two styles are to prevent the scrollbar from shifting the content of the page</style>
